import * as angular from 'angular';
import {DatalayerUtilsService} from '../../ib-datalayer/services/ib-datalayer-utils-service';
import {RedirectionService} from '../../utils/ib-commons-redirection.service';

const selector = 'ibGenericErrorModalComponent';

const options: AngularJSComponent = {
    bindings: {
        resolve: '<',
        modalInstance: '<'
    },
    controllerAs: 'modalCtrl',
    templateUrl: ['$rootScope', ($rootScope: CommonsRootScope) => {
        return `${$rootScope.routes.templates}ib-generic-error-modal.html`;
    }],
    controller: class IbGenericErrorModalComponent {

        public modalInstance;
        public resolve: { object: CommonsModalsModels.GenericErrorComponentModalModel};
        public model: CommonsModalsModels.GenericErrorComponentModalModel;

        constructor (private $window: ng.IWindowService, private DatalayerUtilsService: DatalayerUtilsService, private RedirectionService: RedirectionService) {}

        $onInit () {
            this.model = this.resolve.object ?? {};
            this.DatalayerUtilsService.sendDatalayerErrorEvent(this.model);
            this.modalInstance.result.then(() => {
                this.DatalayerUtilsService.removeDatalayerErrorAttrs();
            }, () => {
                this.DatalayerUtilsService.removeDatalayerErrorAttrs();
            });
        }

        /**
         * Closes the error modal dismissing its instance
         */
        close = (): void => {
            if (!this.checkTimeOutSession() && !this.resolve.object?.redirect) {
                this.modalInstance.dismiss();
            } else {
                this.RedirectionService.externalRedirect(this.resolve.object.redirect ? this.resolve.object.redirect : this.$window.location.origin);
            }
        };

        /**
         * Closes the error modal calling close method of its instance
         */
        accept = (): void  => {
            if (!this.checkTimeOutSession() && !this.resolve.object?.redirect) {
                this.modalInstance.close();
            } else {
                this.RedirectionService.externalRedirect(this.resolve.object.redirect ? this.resolve.object.redirect : this.$window.location.origin);
            }
        };

        private checkTimeOutSession = (): boolean => {
            return (this.resolve.object?.internalErrorCode === 'SSE_ORM_9999' || this.resolve.object?.internalErrorCode === 'SSE_AVM_9008');
        };

    }
};
const inject = ['$window', 'DatalayerUtilsService', 'RedirectionService'];
try {
    const mod = angular.module('ib-commons-modal-service-module');
    options.controller.$inject = inject;
    mod.component(
        selector,
        options
    );
} catch (error) {
    const mod = angular.module('ib-commons-modal-service-module', []);
    options.controller.$inject = inject;
    mod.component(
        selector,
        options
    );
}
